import { Parchment } from 'quill/core';

const ListCollapse = new Parchment.Attributor(
  'list-collapse',
  'list-collapse',
  {
    scope: Parchment.Scope.BLOCK_ATTRIBUTE,
    whitelist: ['true'],
  },
);

export default ListCollapse;
